// extracted by mini-css-extract-plugin
module.exports = {"browseByFeedWidget":"oq_Uh","heading":"lLGK2","feedBtn":"ynsRF"};